module.exports = __webpack_public_path__ + "img/pain_scale.c99bfd1b.jpg";